import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {Provider} from 'react-redux';
import store from "./redux/Store";
import {Router} from 'react-router-dom'
import history from "./history/History";
import {BASE_SUBDOMAIN} from "./helpers/UrlHelper";


ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <Router history={history} basename={BASE_SUBDOMAIN}>
                <App/>
            </Router>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    if (module.hot) {
        module.hot.accept();
    }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
